<template lang="pug">
  .wrap
    TransitionHero
    Sharer.homesharer(:baseurl="config.baseurl", :slug="config.slug", :title="config.title", :description="config.description", :img="config.img", :hashtag="config.hashtag", :brandtitle="config.brandtitle", :reporttitle="config.reporttitle")
    VideoHero(video="content/loop-home-2.mp4", title="About this feature")
      p From the Oscar Award of A Fantastic Woman to the approval of the Gender Identity Act, this has been the year of the Trans Movement. But what is living as a transgender in Chile like? What do we need to understand the transgender phenomenon? Transition – A Digital Feature developed by La Tercera, addresses these and other questions to make the reality of transgender people visible in our country.
      button(@click="toggleModal")
        Button(text="See video")
    Modal(v-if="config.modal")
      VideoPlayer(:iframe="config.home.video" slot="content")
      .modal-header(slot="header")
        Button(text="Close" :icon="['fa', 'times']" @click.native="toggleModal")
        Button(text="See all poems" @click.native="goToRoute({ name: 'experienciastrans'})")
    router-link.transitionarticles(:to="section.slug" v-for="(section, index) in sections" :key="index" v-if="section.looper")
      .transitionswrap
        img(v-for="(article, index) in articles" :key="index" v-if="!article.hidden && !article.wom" :src="article.imgsmall")
      .content.content-title
        header
          h2.title {{section.title}}
            small(v-if="section.undertitle") {{section.undertitle}}
          h4.undertitle(v-if="section.downtitle") {{section.downtitle}}
    router-link(:to="section.slug" v-for="(section, index) in sections" :key="index" v-if="section.inhome")
      Section(:title="section.title", :undertitle="section.undertitle", :downtitle="section.downtitle", :img="section.img")
    Howto
    Credits(:credits="credits")
</template>

<script>
import { mapState, mapActions } from 'vuex'
import VideoHero from '@/components/VideoHero'
import VideoPlayer from '@/components/VideoPlayer'
import RichText from '@/components/RichText'
import TransitionHero from '@/components/transition/TransitionHero'
import Section from '@/components/transition/Section'
import Credits from '@/components/Credits'
import Modal from '@/components/Modal'
import Button from '@/components/Button'
import Sharer from '@/components/Sharer'
import Howto from '@/components/Howto'

export default {
  name: 'home',
  components: {
    TransitionHero,
    VideoPlayer,
    RichText,
    VideoHero,
    Section,
    Credits,
    Modal,
    Button,
    Sharer,
    Howto
  },
  computed: mapState([
    'articles',
    'sections',
    'credits',
    'config'
  ]),
  methods: {
    ...mapActions([
      'toggleModal'
    ]),
    goToRoute(route){
      this.toggleModal()
      this.$router.push(route)
    }
  }
}
</script>
<style scoped lang="scss">
  button{
    background-color: transparent;
    border: none;
    margin: 0 auto;
    display: block;
  }
  .transitionarticles{
    display: block;
    position: relative;
    height: 80vh;
    overflow: hidden;
    position: relative;
    margin-bottom: 10vh;
    // &:hover{
    //   img{
    //     filter: grayscale(0);
    //   }
    // }
    &:before{
      content: '';
      left: 0;
      right: 0;
      bottom: -3px;
      position: absolute;
      z-index: 2;
      height: 30vh;
      background: linear-gradient(transparent, rgba(0,0,0,0.8));
    }
    &:after{
      content: '';
      left: 0;
      right: 0;
      top: -3px;
      position: absolute;
      z-index: 2;
      height: 30vh;
      background: linear-gradient(rgba(0,0,0,0.8), transparent);
    }
    .content-title{
      position: absolute;
      z-index: 3;
      bottom: 0;
      left: 0;
      right: 0;
      top: 0;
      z-index: 3;
      display: flex;
      align-items: center;
      justify-content: center;
      header{
        max-width: $maxwidth;
        margin-left: auto;
        margin-right: auto;
        @media (max-width: 800px){
          padding: 0 1rem;
          max-width: 100%;
        }
      }
    }
    .undertitle{
      @include fluid-type(360px,
    1440px,
    18px,
    26px);
      line-height: 160%;
      // font-family: 'Open Sans', sans-serif;
      text-align: center;
      font-weight: 400;
    }
    h4{
      color: white;
    }

    .title{
      max-width: $maxwidth;
      margin-left: auto;
      margin-right: auto;
      @media (max-width: 800px){
        padding: 0 1rem;
        max-width: 100%;
      }
    }
    h2{
    @include fluid-type(360px,
    1440px,
    42px,
    96px);
      text-align: center;
      // margin-bottom: 2rem;
      // text-shadow: 1px 1px 0px rgba(black, 0.9), 1px 2px 3px rgba(black, 0.2) ;
      color: white;
      font-family: 'LaTercera', sans-serif;
      text-transform: uppercase;
      letter-spacing: 1px;
      small{
        display: block;
        font-size: 3rem;
        line-height: 3rem;
      }
    }
  }
  .transitionswrap{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);
    position: relative;
    height: 80vh;
    overflow: hidden;
    img{
      max-height: 40vh;
      display: block;
      position: relative;
      object-fit: cover;
      object-position: center;
      width: 100%;
      height: 100%;
      object-position: center;
      display: block;
      // filter: grayscale(100%);
      transition: all .3s;
    }
  }
  .homesharer{
    margin-bottom: 2rem;
  }
</style>
